import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { launchRouting, } from './launch-routing.module';
import { IndexComponent } from './index/index.component';


@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    launchRouting
  ]
})
export class LaunchModule { }
